import React from 'react';

class Rating extends React.Component {
    render() {
        return (
            <div className="rating">
                <h3>{this.props.name}</h3>
                <p>{this.props.description}</p>
                <div>
                    <button className={this.props.selected === 1 ? "selected" : null} onClick={this.props.click.bind(this, this.props.name, 1)}>1</button>
                    <button className={this.props.selected === 2 ? "selected" : null} onClick={this.props.click.bind(this, this.props.name, 2)}>2</button>
                    <button className={this.props.selected === 3 ? "selected" : null} onClick={this.props.click.bind(this, this.props.name, 3)}>3</button>
                    <button className={this.props.selected === 4 ? "selected" : null} onClick={this.props.click.bind(this, this.props.name, 4)}>4</button>
                    <button className={this.props.selected === 5 ? "selected" : null} onClick={this.props.click.bind(this, this.props.name, 5)}>5</button>
                </div>
                <div>
                    <p>😭</p>
                    <p></p>
                    <p>😐</p>
                    <p></p>
                    <p>😍</p>
                </div>
            </div>
        )
    }
}

export default Rating;